import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {draw,drawpool, winners,drawpoolitem,winnerItem,predraw,drawpoolExport,rollpoolExport,toReceived,winnersByPage,
    rollpools,rollpoolCreate,rollpool,rollpoolRecover,adminRollpools,rollpoolItems,scan,roll,winnersPoolItems,
    receivedItems,attendeeWinners,attendeeWinners2,pushRollWinner,rollpoolCountWinners,drawpoolLogo,rollpoolLogo,
    rollpoolBwLists,rollpoolBwList,rollpoolOrder,drawpoolBwLists,drawpoolBwList
} = api

/**
 * 查找奖池
 */
export async function findDrawpool(params) {
    return request({url: drawpool, method: 'get', data: params,})
}

/**
 * 更新奖池
 */
export async function updateDrawpool(params) {
    return request({url: drawpool, method: 'put', data: params,})
}
/**
 * 更新logo
 */
export async function updateDrawpoolLogo(params) {
    return request({url: drawpoolLogo+'?eventId='+params.eventId+'&logo='+params.logo, method: 'put', data: params,})
}

/**
 * 更新/创建奖项
 */
export async function updateDrawpoolitem(params) {
    return request({url: drawpoolitem, method: 'patch', data: params,})
}



/**
 * 抽奖
 */
export async function playDraw(params) {
    return request({url: `${draw}?poolItemId=${params.id}&eventId=${params.eventId}`, method: 'post', data: params,})
}
/**
 * 查找中奖名单
 */
export async function findWinners(params) {
    return request({url: winners, method: 'get', data: params,})
}
/**
 * 查找单个奖项中奖名单
 */
export async function findWinner(params) {
    return request({url: winnerItem, method: 'get', data: params,})
}
/**
 * 清空中奖人名单
 */
export async function emptyWinner(params) {
    return request({url: winners+'?eventId='+params.eventId, method: 'delete', data: params,})
}
/**
 * 删除中奖人名单
 */
export async function deleteWinner(params) {
    return request({url: winners, method: 'post', data: params,})
}

/**
 * 清空摇奖中奖人名单
 */
export async function emptyAttendeeWinner(params) {
    return request({url: attendeeWinners2, method: 'delete', data: params,})
}
/**
 * 删除摇奖中奖人名单
 */
export async function deleteAttendeeWinner(params) {
    return request({url: attendeeWinners2, method: 'post', data: params,})
}
/**
 * 查找候选人
 */
export async function findPredraw(params) {
    return request({url: predraw, method: 'get', data: params,})
}
/**
 * 查找中奖列表
 */
export async function findWinnersByPage(params) {
    return request({url: winnersByPage, method: 'get', data: params,})
}/**
 * 派奖
 */
export async function sendToReceived(params) {
    return request({url: toReceived, method: 'get', data: params,})
}/**
 * 导出
 */
export async function exportDrawpoll(params) {
    return request({url: drawpoolExport, method: 'get', data: params,})
}

//参与人抽奖

/**
 * 查找奖池列表
 */
export async function findRollpools(params) {
    return request({url: rollpools, method: 'get', data: params,})
}
/**
 * 查找奖池列表
 */
export async function fetchAdminRollpools(params) {
    return request({url: adminRollpools, method: 'get', data: params,})
}
/**
 * 查找奖池
 */
export async function findRollpool(params) {
    return request({url: rollpool, method: 'get', data: params,})
}
/**
 * 创建奖池
 */
export async function createRollpool(params) {
    return request({url: rollpoolCreate, method: 'post', data: params,})
}
/**
 * 更新奖池
 */
export async function updateRollpool(params) {
    return request({url: rollpool, method: 'put', data: params,})
}
/**
 * 更新logo
 */
export async function updateRollpoolLogo(params) {
    return request({url: rollpoolLogo+'?logo='+params.logo, method: 'put', data: params,})
}
/**
 * 删除奖池
 */
export async function deleteRollpool(params) {
    return request({url: rollpool, method: 'delete', data: params,})
}

/**
 * 恢复奖池
 */
export async function recoverRollPool(params) {
    return request({url: rollpoolRecover, method: 'put', data: params,})
}
/**
 * 更新/创建奖项
 */
export async function updateRollpoolItems(params) {
    return request({url: rollpoolItems, method: 'patch', data: params,})
}
/**
 * 判断是否有抽奖资格
 */
export async function getScanitem(params) {
    return request({url: scan, method: 'post', data: params,})
}/**
 * 开始摇奖
 */
export async function startRoll(params) {
    return request({url: roll, method: 'get', data: params,})
}/**
 * 中奖礼品
 */
export async function findWinnersPoolItems(params) {
    return request({url: winnersPoolItems, method: 'get', data: params,})
}
/**
 * 领取礼品
 */
export async function getReceivedItems(params) {
    return request({url: receivedItems, method: 'get', data: params,})
}/**
 * 中奖名单
 */
export async function findAttendeeWinners(params) {
    return request({url: attendeeWinners, method: 'get', data: params,})
}
/**
 * 中奖名单
 */
export async function sendPushRollWinner(params) {
    return request({url: pushRollWinner, method: 'get', data: params,})
}
/**
 * 导出
 */
export async function exportRollpoll(params) {
    return request({url: rollpoolExport, method: 'get', data: params,})
}
/**
 * 查询参与人数和中奖人数
 */
export async function findRollpoolCountWinners(params) {
    return request({url: rollpoolCountWinners, method: 'get', data: params,})
}
/**
 * 黑白名单
 */
export async function findRollpoolBwLists(params) {
    return request({url: rollpoolBwLists, method: 'get', data: params,})
}

export async function createRollpoolBwLists(params) {
    return request({url: rollpoolBwLists, method: 'post', data: params,})
}

export async function deleteRollpoolBwList(params) {
    return request({url: rollpoolBwList, method: 'delete', data: params,})
}


export async function findDrawpoolBwLists(params) {
    return request({url: drawpoolBwLists, method: 'get', data: params,})
}

export async function createDrawpoolBwLists(params) {
    return request({url: drawpoolBwLists, method: 'post', data: params,})
}

export async function deleteDrawpoolBwList(params) {
    return request({url: drawpoolBwList, method: 'delete', data: params,})
}
export async function findRollpoolOrder(params) {
    return request({url: rollpoolOrder, method: 'put', data: params,})
}




// WEBPACK FOOTER //
// ./src/services/luckydraw.js